import { IPartner } from 'clickNgo/entities/partner/models'

import { fetchCountryByName } from '../../../dictionaries/countries/fetchCountryByName'
import { mapApolloSearchPartnerTermsFromPartner } from '../mapping/mapApolloSearchPartnerTermsFromPartner'

export const getApolloSearchTerms = async (partner: IPartner) => {
  const apolloSearchTerms = mapApolloSearchPartnerTermsFromPartner(partner)

  if (!apolloSearchTerms.country) {
    const country = await fetchCountryByName(partner.country)
    if (country) {
      apolloSearchTerms.country = country.code
    }
  }

  return apolloSearchTerms
}
